module.exports = __webpack_public_path__ + "img/two-btn-right.3a1f8f86.svg";